import axios from '../../utils/axios';
import { ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';
import { apiEndpoint } from '../../utils/apiEndpointUtility';

import {
	collectContactInfo,
	collectContactInfoCompleted,
	collectContactInfoFailed
} from './collectContactInfoSlice';

export const collectContactInfoEpic = (action$) =>
	action$.pipe(
		ofType(collectContactInfo),
		mergeMap(async (action) => {
			try {
				const contactInfo = action.payload;
				const response = await axios.post(
					`${apiEndpoint()}/api/v2/checkout/contact`,
					contactInfo
				);

				if (response.status !== 200) {
					throw new Error(response.data);
				}
				return response.data;
			} catch (e) {
				throw e;
			}
		}),
		switchMap((response) => [collectContactInfoCompleted(response)]),
		catchError((error, source) =>
			merge(of(collectContactInfoFailed(error.message)), source)
		)
	);

export default [collectContactInfoEpic];
